export var LambdaSource;
(function (LambdaSource) {
    LambdaSource[LambdaSource["Unknown"] = 0] = "Unknown";
    LambdaSource[LambdaSource["Local"] = 1] = "Local";
    LambdaSource[LambdaSource["Custom"] = 2] = "Custom";
    LambdaSource[LambdaSource["Remote"] = 3] = "Remote";
    LambdaSource[LambdaSource["BatchedRemote"] = 4] = "BatchedRemote";
})(LambdaSource || (LambdaSource = {}));
//# sourceMappingURL=runtime-types.js.map